import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function LukosUnifiedBanner() {
  return (
    <section className="relative w-full min-h-[580px] flex items-center justify-center overflow-hidden">
      
      {/* ── BACKGROUND VIDEO (LukIA em ação) ── */}
      <div className="absolute inset-0 z-0">
        <video
          className="w-full h-full object-cover"
          src="/videos-hub/videos/serie-lukia-horizontal.mp4"
          poster="/lukos_tech_bg.png"
          autoPlay
          muted
          loop
          playsInline
        />
        {/* Overlays for readability and brand feel */}
        <div className="absolute inset-0 bg-black/60" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/40" />
        <div className="absolute inset-0 bg-[#7f00ff]/10" />
      </div>

      {/* ── CONTENT (Centered) ── */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h2 className="text-white text-3xl md:text-5xl lg:text-[54px] font-bold leading-[1.15] mb-8 tracking-tight font-outfit">
            A Inteligência de Dados da Lukos permite que <br className="hidden md:block" />
            seu posto alcance novos níveis de <br className="hidden md:block" />
            <span className="text-white">lucratividade e segurança.</span>
          </h2>

          <p className="text-white/70 text-lg md:text-xl mb-12 max-w-2xl mx-auto font-medium">
            Gestão que fica mais inteligente a cada transação, <br className="md:hidden" /> antecipando tendências e blindando seu caixa.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-8">
            <Link
              to="/contato"
              className="inline-flex items-center gap-3 bg-[#00D1FF] hover:bg-[#00B8E0] text-black font-black px-10 py-4 rounded-full transition-all duration-300 hover:scale-105 shadow-[0_15px_35px_rgba(0,209,255,0.3)] text-[16px]"
            >
              Veja como a Lukos funciona <ArrowRight size={18} />
            </Link>
            
            <Link
              to="/solucoes"
              className="text-white font-bold text-lg border-b-2 border-white/30 hover:border-white transition-all pb-1"
            >
              Saiba mais
            </Link>
          </div>
        </motion.div>

      </div>

    </section>
  );
}
